import * as React from "react";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Box from "@mui/material/Box";

export default function DateRangePicker({ setDateRange }) {
  const [start, setStart] = React.useState(null);
  const [end, setEnd] = React.useState(null);

  const handleStartChange = (value) => {
    setStart(value);
    if (value && end) {
      setDateRange({
        start_date: value.startOf("day").toISOString(),
        end_date: end.endOf("day").toISOString(),
      });
    }
  };

  const handleEndChange = (value) => {
    setEnd(value);
    if (start && value) {
      setDateRange({
        start_date: start.startOf("day").toISOString(),
        end_date: value.endOf("day").toISOString(),
      });
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ display: "flex", gap: 2, width: "400px" }}>
        <DatePicker
          label="Start Date"
          value={start}
          onChange={handleStartChange}
          maxDate={dayjs()}
        />
        <DatePicker
          label="End Date"
          value={end}
          onChange={handleEndChange}
          maxDate={dayjs()}
        />
      </Box>
    </LocalizationProvider>
  );
}
